import { FuseLoadable } from '@fuse';

export const SignUpPageConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false
        },
        toolbar: {
          display: false
        },
        footer: {
          display: false
        },
        leftSidePanel: {
          display: false
        },
        rightSidePanel: {
          display: false
        }
      }
    }
  },
  routes: [
    {
      path: '/register',
      component: FuseLoadable({
        loader: () => import('./SignUpPage')
      })
    },
    {
      path: '/sms_verification',
      component: FuseLoadable({
        loader: () => import('./SMSVerification')
      })
    }
  ]
};
